import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { HIRE_AND_REWARD, TEMPORARY_COVER_STATUTORY_LIMIT_KEY, WORKERS_COMPENSATION_COVER, apiGetCovers, formatCurrency, onlyTrueValueList } from '@jove-frontend/uikit';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
export var useCoverStore = create()(immer(function (set, get) {
  return {
    state: {
      covers: [],
      currency: null
    },
    actions: {
      initialize: function () {
        var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(currency) {
          var covers, setCurrency, fetchCovers;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  covers = get().state.covers;
                  setCurrency = get().actions.setCurrency;

                  if (!(covers.length === 0)) {
                    _context.next = 6;
                    break;
                  }

                  fetchCovers = get().actions.fetchCovers;
                  _context.next = 6;
                  return fetchCovers();

                case 6:
                  setCurrency(currency);

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function initialize(_x) {
          return _initialize.apply(this, arguments);
        }

        return initialize;
      }(),
      setCurrency: function setCurrency(currency) {
        set(function (store) {
          store.state.currency = currency;
        });
      },
      fetchCovers: function () {
        var _fetchCovers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _yield$apiGetCovers, _yield$apiGetCovers2, res, err;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return apiGetCovers();

                case 2:
                  _yield$apiGetCovers = _context2.sent;
                  _yield$apiGetCovers2 = _slicedToArray(_yield$apiGetCovers, 2);
                  res = _yield$apiGetCovers2[0];
                  err = _yield$apiGetCovers2[1];

                  if (res) {
                    set(function (store) {
                      store.state.covers = res.map(function (c) {
                        return c.cover;
                      });
                    });
                  }

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function fetchCovers() {
          return _fetchCovers.apply(this, arguments);
        }

        return fetchCovers;
      }(),
      getCoverById: function getCoverById(id) {
        var covers = get().state.covers;
        return covers.find(function (c) {
          return c.id === id;
        });
      },
      getCoversByCategory: function getCoversByCategory(category) {
        var covers = get().state.covers;
        return covers.filter(function (cover) {
          return cover.categories.find(function (c) {
            return c.id === (category === null || category === void 0 ? void 0 : category.id);
          });
        });
      },
      getAmountOptions: function getAmountOptions(cover, currency, config) {
        var stateCurrency = get().state.currency;
        var values = [];

        if (cover) {
          switch (cover.slug) {
            case 'goods-in-transit':
              values = [{
                value: 5000
              }, {
                value: 10000
              }, {
                value: 20000
              }, {
                value: 30000
              }, {
                value: 40000
              }, {
                value: 50000
              }, {
                value: 100000
              }, {
                value: 200000
              }, {
                value: 300000
              }, {
                value: 400000
              }, {
                value: 500000
              }];
              break;

            case 'hired-in-plant':
              values = [{
                value: 10000
              }, {
                value: 20000
              }, {
                value: 30000
              }, {
                value: 40000
              }, {
                value: 50000
              }, {
                value: 100000
              }, {
                value: 200000
              }, {
                value: 300000
              }, {
                value: 400000
              }, {
                value: 500000
              }];
              break;

            case 'ir35-insurance':
              values = [{
                value: 50000
              }, {
                value: 100000
              }, {
                value: 150000
              }, {
                value: 200000
              }, {
                value: 250000
              }];
              break;

            case 'hire-and-reward':
              values = [{
                value: 0
              }];
              break;

            default:
              values = [{
                value: 250000
              }, {
                value: 500000
              }, {
                value: 1000000
              }, {
                value: 2000000
              }, {
                value: 3000000
              }, {
                value: 4000000
              }, {
                value: 5000000
              }, {
                value: 10000000
              }, {
                value: 15000000
              }, {
                value: 20000000
              }];
          }
        }

        var list = values.map(function (_ref) {
          var value = _ref.value;
          return {
            value: value,
            label: value === 0 ? 'Included' : formatCurrency({
              amount: value,
              currency: currency || stateCurrency || 'GBP',
              options: {
                minimumFractionDigits: 0
              }
            })
          };
        });

        if (config !== null && config !== void 0 && config.haveStatutoryLimit && (cover === null || cover === void 0 ? void 0 : cover.slug) !== HIRE_AND_REWARD) {
          list.push({
            value: TEMPORARY_COVER_STATUTORY_LIMIT_KEY,
            label: 'Statutory limits'
          });
        }

        if ((cover === null || cover === void 0 ? void 0 : cover.slug) === WORKERS_COMPENSATION_COVER) {
          list = onlyTrueValueList;
        }

        return list;
      },
      reset: function reset() {
        set(function (store) {
          store.state.covers = [];
          store.state.currency = null;
        });
      }
    }
  };
}));